import {take} from 'redux-saga/effects';
import {redirect} from 'helpers';

export function* redirects() {
  while (true) {
    const { historyReplace, historyPush, generateId } = yield take(({ historyReplace, historyPush }) => historyReplace || historyPush);
    const injectIds = value => {
      return value.replace(/{(\d+)}/g, (_, id) => id)
                  .replace(/{(\w+)}/g, (_, key) => generateId(key));
    }
    if (historyReplace) {
      redirect(injectIds(historyReplace), true);
    }
    if (historyPush) {
      redirect(injectIds(historyPush));
    }
  }
}
